import React, { useState, useContext, useEffect, useRef } from 'react';
import { AppContext } from '../Context/AppContext';
import StudentDetails from '../student/components/StudentDetails/StudentDetails';
import StudentHomework from '../student/components/StudentHomework/StudentHomework';
import QuickPeek from '../student/components/QuickPeek/QuickPeek';
import Timetable from '../student/components/Timetable/Timetable';
import ResultView from "../student/components/Result/ResultView";
import GradeCalculator from "../student/components/GradeCalculator/GradeCalculator";
import Downloads from "../components/Downloads";
import styles from './StudentPage.module.css';
import { clearLocalStorage } from '../admin/utility/localStorage';
import { useNavigate } from 'react-router-dom';

const StudentPage = () => {
  const { user, logout } = useContext(AppContext);
  const navigate = useNavigate();
  const [activeLink, setActiveLink] = useState('quickpeek');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const sidebarRef = useRef(null);

  const handleLogout = () => {
    logout();
    clearLocalStorage();
    navigate('/home');
  };

  const handleLinkClick = (link) => {
    setActiveLink(link);
    setIsSidebarOpen(false);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Close sidebar on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
          isSidebarOpen &&
          sidebarRef.current &&
          !sidebarRef.current.contains(e.target) &&
          !e.target.closest(`.${styles.menuButton}`)
      ) {
        setIsSidebarOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isSidebarOpen]);

  // Removed Personal Details from sidebar
  const side_links = [
    { title: 'Quick Peek', link: 'quickpeek' },
    { title: 'View Homework', link: 'homework' },
    {title: 'Timetable', link: 'timetable'},
    { title: 'Result', link: 'result' },
    {title: 'Grade Calculator', link: 'grade-calculator'},
    {title: 'Downloads', link: 'downloads'},
  ];

  return (
      <div className={styles.container}>
        {/* Navbar */}
        <header className={styles.navbar}>
          <div className={styles.navbarLeft}>
            <button className={styles.menuButton} onClick={toggleSidebar}>☰</button>
            <h1 className={styles.heading}>Student Dashboard</h1>
          </div>
          <div className={styles.navbarRight}>
            {/* New clickable user icon */}
            <a
                className={styles.userIconButton}
                onClick={() => handleLinkClick('details')}
                title="View Personal Info"
            >
              <img
                  src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWNpcmNsZS11c2VyLWljb24gbHVjaWRlLWNpcmNsZS11c2VyIj48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMCIvPjxjaXJjbGUgY3g9IjEyIiBjeT0iMTAiIHI9IjMiLz48cGF0aCBkPSJNNyAyMC42NjJWMTlhMiAyIDAgMCAxIDItMmg2YTIgMiAwIDAgMSAyIDJ2MS42NjIiLz48L3N2Zz4="
                  alt="User Icon"
                  className={styles.userIcon}
              />
            </a>
            <span className={styles.username}>
            {user?.firstName + ' ' + user?.lastName}
          </span>
            <button className={styles.logoutButton} onClick={handleLogout}>Log out</button>
          </div>
        </header>

        {/* Layout */}
        <div className={styles.content}>
          {/* Sidebar */}
          <aside
              ref={sidebarRef}
              className={`${styles.sidebar} ${isSidebarOpen ? styles.sidebarOpen : ''}`}
          >
            <ul className={styles.sidebarLinks}>
              {side_links.map((item) =>
                  item.link === 'external' ? (
                      <li key={item.title}>
                        <a href={item.url} target="_self" rel="noopener noreferrer">
                          {item.title}
                        </a>
                      </li>
                  ) : (
                      <li key={item.link}>
                        <a
                            onClick={() => handleLinkClick(item.link)}
                            className={activeLink === item.link ? styles.activeLink : ''}
                            href="#!"
                        >
                          {item.title}
                        </a>
                      </li>
                  )
              )}
            </ul>
          </aside>

          {/* Main Content */}
          <main className={styles.mainContent}>
            {activeLink === 'quickpeek' ? (
                <QuickPeek onNavigateToHomework={() => setActiveLink('homework')} />
            ) : activeLink === 'homework' ? (
                <StudentHomework />
            ) : activeLink === 'timetable' ? (
                <Timetable />
            ) : activeLink === 'grade-calculator' ? (
                <GradeCalculator />
            ) :
            activeLink === 'downloads' ? (
                <Downloads />
            ) :
                activeLink === 'result' ? (
                <ResultView />
            ) : (
                <StudentDetails activeLink={activeLink} />
            )
            }
          </main>
        </div>
      </div>
  );
};

export default StudentPage;
